export default "__VITE_ASSET__CvPp4RNZ__"